enum Role {
  ADMIN = 'ADMIN',
  OPERATOR = 'OPERATOR',
  KM_ADMIN = 'KM_ADMIN',
  MAINTENANCE = 'MAINTENANCE',
  BATTERY = 'BATTERY',
  BATCH_MAINTENANCE = 'BATCH_MAINTENANCE',
  INSURANCE = 'INSURANCE',
}

export default Role
